import { wpAjaxFetch } from "../../../helpers/customFetch";

document.addEventListener("DOMContentLoaded", () => {
  const faculties = document.querySelector(".main-taxonomy-faculties");
  if (!faculties) return;

  const getSafeElement = (selector, parent = faculties) =>
    parent?.querySelector(selector) ?? null;

  const showElement = (el, show = true) =>
    el && (el.style.display = show ? "block" : "none");

  const toggleClass = (el, className, add) =>
    el && el.classList[add ? "add" : "remove"](className);

  const currentTaxQuery = document.querySelector(".filter-programs");
  const paginates = document.querySelector("#pagination-data");
  let totalPages = parseInt(paginates?.dataset?.totalPages) || 1;

  function setupPaginationEvents() {
    const paginationLinks = document.querySelectorAll(".pagination__target");
    paginationLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        const page = parseInt(link.dataset.page, 10);
        if (!isNaN(page)) {
          currentFilters.page = page;
          updatePagination(page, totalPages);
          handleFilterChange();
        }
      });
    });
  }

  function updatePagination(currentPage, totalPages) {
    let paginationHTML = "";
    if (totalPages > 1) {
      if (currentPage > 1) {
        paginationHTML += `<a href='#programs' class="pagination__link pagination__target" data-page="${
          currentPage - 1
        }">Anterior</a>`;
      }
      for (let i = 1; i <= totalPages; i++) {
        if (i === currentPage) {
          paginationHTML += `<span class="pagination__page pagination__page--current-page">${i}</span>`;
        } else {
          paginationHTML += `<a href='#programs' class="pagination__page pagination__target" data-page="${i}">${i}</a>`;
        }
      }
      if (currentPage < totalPages) {
        paginationHTML += `<a href='#programs' class="pagination__link pagination__target" data-page="${
          currentPage + 1
        }">Siguiente</a>`;
      }
    }
    const paginationContainer = document.getElementById("ajax-pagination");
    if (paginationContainer) {
      paginationContainer.innerHTML = paginationHTML;
      setupPaginationEvents();
    }
  }

  const elements = {
    currentTaxQuery: currentTaxQuery?.dataset?.taxQuery,
    facultie: faculties.dataset.taxonomy,
    searchInput: getSafeElement("#search-programs"),
    typeProgram: getSafeElement("#type-program"),
    durationProgram: getSafeElement("#duration-program"),
    locationProgram: getSafeElement("#location-program"),
    daysOfWeek: getSafeElement("#days-of-weekend"),
    modality: getSafeElement("#modality"),
    typeForm: getSafeElement("#tipe-form"),
    loader: getSafeElement(".full-programs__loader"),
    renderCards: getSafeElement(".full-programs__wrapper"),
    filtersContainer: getSafeElement(".filter-programs__filters"),
    tabs: Array.from(
      faculties.querySelectorAll(".filter-programs__tabs--button")
    ),
    descriptionTabs: getSafeElement(".filter-programs__tabs--p"),
  };

  const resetButton = createResetButton();
  elements.filtersContainer?.appendChild(resetButton);

  const noResultsContainer = createNoResultsContainer();
  elements.renderCards?.parentNode?.insertBefore(
    noResultsContainer,
    elements.renderCards.nextSibling
  );

  let searchTimer;
  const currentFilters = {
    current_tax_query: elements.currentTaxQuery || "",
    taxonomy: elements.facultie,
    search: "",
    type: "",
    duration: "",
    location: "",
    days_of_weekend: "",
    modality: "",
    type_form: "",
    child_taxonomy: "",
    group_by_day: false,
    page: 1,
  };

  setupEventListeners();
  if (paginates && totalPages > 1) updatePagination(1, totalPages);

  function createResetButton() {
    const button = document.createElement("button");
    button.className = "full-programs__reset-button";
    button.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 7H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M6 7V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`;
    button.style.display = "none";
    return button;
  }

  function createNoResultsContainer() {
    const container = document.createElement("div");
    container.className = "full-programs__no-results";
    container.innerHTML = `<div class="full-programs__no-results-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 8V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div><h3 class="full-programs__no-results-title">No se encontraron resultados</h3><p class="full-programs__no-results-message">Intenta ajustando tus filtros de búsqueda</p>`;
    container.style.display = "none";
    return container;
  }

  function resetFilters() {
    const resetValues = {
      searchInput: "",
      typeProgram: "",
      durationProgram: "",
      locationProgram: "",
      daysOfWeek: "",
      modality: "",
      typeForm: "",
    };
    Object.entries(resetValues).forEach(([key, value]) => {
      if (elements[key]) elements[key].value = value;
    });
    resetButton.style.display = "none";
    removeSearchClearButton();
    Object.assign(currentFilters, {
      search: "",
      type: "",
      duration: "",
      location: "",
      days_of_weekend: "",
      modality: "",
      type_form: "",
      page: 1,
    });
    handleFilterChange();
  }

  function setupEventListeners() {
    if (elements.searchInput) {
      elements.searchInput.addEventListener("input", () => {
        if (elements.searchInput.value.trim()) {
          addSearchClearButton();
        } else {
          removeSearchClearButton();
        }
        handleFilterChange();
      });
      elements.searchInput.addEventListener("keypress", (e) => {
        if (e.key === "Enter") {
          clearTimeout(searchTimer);
          handleFilterChange();
        }
      });
    }

    resetButton.addEventListener("click", resetFilters);

    elements.tabs.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        e.preventDefault();
        elements.tabs.forEach((t) => t.classList.remove("isActive"));
        tab.classList.add("isActive");
        currentFilters.child_taxonomy = tab.value;
        currentFilters.group_by_day = true;
        handleFilterChange();
        elements.descriptionTabs.textContent = tab.dataset.description || "";
      });
    });

    [
      elements.typeProgram,
      elements.durationProgram,
      elements.locationProgram,
      elements.daysOfWeek,
      elements.modality,
      elements.typeForm,
    ]
      .filter(Boolean)
      .forEach((select) => {
        select.addEventListener("change", handleFilterChange);
      });
  }

  function addSearchClearButton() {
    if (elements.searchInput.nextSibling?.classList?.contains("clear-search"))
      return;
    const isButtonClear =
      elements.searchInput.parentNode.querySelector(".clear-search");

    if (isButtonClear) {
      return;
    }
    const clearBtn = document.createElement("span");
    clearBtn.className = "clear-search";
    clearBtn.innerHTML = "&times;";
    clearBtn.style.position = "absolute";
    clearBtn.style.right = "10px";
    clearBtn.style.cursor = "pointer";
    clearBtn.addEventListener("click", () => {
      elements.searchInput.value = "";
      removeSearchClearButton();
      handleFilterChange();
    });
    elements.searchInput.parentNode.style.position = "relative";
    elements.searchInput.parentNode.appendChild(clearBtn);
  }

  function removeSearchClearButton() {
    const clearBtn =
      elements.searchInput?.parentNode?.querySelector(".clear-search");
    clearBtn?.remove();
  }

  function updateCurrentFilters() {
    Object.assign(currentFilters, {
      search: elements.searchInput?.value.trim().toLowerCase() ?? "",
      type: elements.typeProgram?.value ?? "",
      duration: elements.durationProgram?.value ?? "",
      location: elements.locationProgram?.value ?? "",
      days_of_weekend: elements.daysOfWeek?.value ?? "",
      modality: elements.modality?.value ?? "",
      type_form: elements.typeForm?.value ?? "",
      group_by_day: faculties.classList.contains(
        "main-taxonomy-faculties-childrens"
      ),
    });
    const hasActiveFilters = Object.entries(currentFilters)
      .filter(
        ([key]) => !["taxonomy", "facultie", "group_by_day"].includes(key)
      )
      .some(([, value]) => value !== "" && value !== false);
    resetButton.style.display = hasActiveFilters ? "inline-flex" : "none";
  }

  function handleFilterChange() {
    updateCurrentFilters();
    clearTimeout(searchTimer);
    toggleClass(elements.loader, "isVisible", true);
    elements.renderCards && (elements.renderCards.textContent = "");
    showElement(noResultsContainer, false);
    searchTimer = setTimeout(() => {
      wpAjaxFetch("get_data_filter", currentFilters)
        .then(({ data }) => {
          if (elements.renderCards) {
            if (data.html?.trim()) {
              elements.renderCards.innerHTML = data.html;
              showElement(noResultsContainer, false);
            } else {
              elements.renderCards.textContent = "";
              showElement(noResultsContainer, true);
            }
          }
          if (data.total_pages) {
            totalPages = data.total_pages;
            updatePagination(currentFilters.page, data.total_pages);
          }
        })
        .catch((error) => {
          console.error("Error en la búsqueda:", error);
          elements.renderCards && (elements.renderCards.textContent = "");
          const message = noResultsContainer.querySelector(
            ".full-programs__no-results-message"
          );
          message && (message.textContent = "Error al cargar los programas");
          showElement(noResultsContainer, true);
        })
        .finally(() => {
          toggleClass(elements.loader, "isVisible", false);
        });
    }, 500);
  }
});
